<template>
    <div class="incoming glass-theme">
        <!-- API Loading Overlay with Animation -->
        <transition name="loading-overlay">
            <div v-if="apiLoading" class="loading-overlay">
                <div class="loading-card">
                    <div class="loading-animation">
                        <div class="loading-ring">
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="loading-logo">
                                <i class="fas fa-boxes"></i>
                            </div>
                        </div>
                    </div>
                    <div class="loading-text">
                        <h3>{{ loadingMessage }}</h3>
                        <div class="loading-dots">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                    <div class="loading-progress">
                        <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                    </div>
                    <div class="loading-tips">
                        <p class="tip-text">{{ currentTip }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <b-modal id="modal-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
            <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
        </b-modal>

        <div style="width: 100%;">
            <div>
                <div class="d-flex flex-wrap" style="gap: 7px;">
                    <b-alert variant="secondary" show class="glass-alert" style="display: inline-block; vertical-align: top;">
                        <div v-if="this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id" style="display: inline-block; vertical-align: top;">
                            <b-form-select size="sm" :options="get_locations()" v-model="drop_location" class="glass-select">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- COMING TO --</b-form-select-option>
                                </template>
                            </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                            <b-button variant="success" style="display: inline-block;" size="sm" @click="fetch_init2" class="glass-btn">SEARCH</b-button>
                        </div>
                    </b-alert>

                    <!-- Date, Driver, Status, Pick From, Drop Location, Delivery Location and Order Type Filters -->
                    <div
                      v-if="isMobile && items.length > 0"
                      class="d-flex justify-content-between align-items-center mb-2 px-1"
                    >
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        @click="filtersVisible = !filtersVisible"
                        class="glass-filter-btn"
                      >
                        <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
                        {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
                      </b-button>
                    </div>

                    <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
                      <b-alert
                        variant="primary"
                        show
                        style="display: flex; flex-wrap: wrap; gap: 7px; vertical-align: top; padding: 13px;"
                        v-if="items.length > 0"
                        class="glass-filters"
                      >
                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_date"
                            :options="available_dates"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- SELECT DATE --</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_driver"
                            :options="available_drivers"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- SELECT DRIVER --</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_status"
                            :options="available_statuses"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- STATUS --</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_pick_from"
                            :options="available_pick_from_locations"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- ITEM PICK FROM --</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_drop_location"
                            :options="available_drop_locations"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- DROP LOCATION --</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_delivery_location"
                            :options="available_delivery_locations"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- DELIVERY LOCATION --</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>

                        <div style="display: inline-block; vertical-align: top;">
                          <b-form-select
                            v-model="selected_order_type"
                            :options="available_order_types"
                            size="sm"
                            style="width: 180px;"
                            class="glass-select"
                          >
                            <template #first>
                              <b-form-select-option :value="null" disabled>-- ORDER TYPE --</b-form-select-option>
                            </template>
                          </b-form-select>
                        </div>
                      </b-alert>
                    </b-collapse>
                </div>
            </div>
        </div>

        <div style="width: 100%; padding: 5px; min-height: 200px;">
            <div>
                <div v-if="items_being_loaded == true">
                    <!-- <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="false">
                    </loading> -->
                </div>
                <div v-else>
                    <div v-if="filtered.length > 0" class="diver">
                        <table style="width: 100%;" class="glass-table">
                            <thead>
                                <tr>
                                    <td class="srr glass-table-header" style="width: 100px;" @click="sortby('invoice_id')">
                                        INVOICE #
                                    </td>
                                    <td class="srr glass-table-header" style="width: 100px;">
                                        DELIVERY DATE
                                    </td>
                                    <td class="srr glass-table-header" style="width: 100px;" @click="sortby('product_sku')">
                                        PRD SKU
                                    </td>
                                    <td class="srr glass-table-header" style="width: 220px;" @click="sortby('product_name')">
                                        PRD NAME
                                    </td>
                                    <td class="srr glass-table-header" style="width:120px;" @click="sortby('order_type')">
                                        ORDER TYPE
                                    </td>
                                    <td class="srr glass-table-header" style="width: 50px;" @click="sortby('quantity')">
                                        QTY
                                    </td>
                                    <td class="srr glass-table-header" style="width: 220px;" @click="sortby('locsub')">
                                        ITEM PICK FROM
                                    </td>
                                    <td class="srr glass-table-header" style="width: 220px;" @click="sortby('ship_locsub')">
                                        DROP LOC
                                    </td>
                                    <td class="srr glass-table-header" style="width: 220px;" @click="sortby('drop_locsub')">
                                        DELIVERY LOC
                                    </td>
                                    <td class="srr glass-table-header" style="width:80px;" @click="sortby('pickup_truck')">
                                        PICKUP TRUCK
                                    </td>
                                    <td class="srr glass-table-header" style="width:230px;" @click="sortby('state')">
                                        STATUS
                                    </td>
                                    <td class="srr glass-table-header" style="width:80px;">
                                        ACTION
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item,idx in filtered" v-bind:key="idx" class="glass-table-row">
                                    <td class="srrv">
                                        {{ item.invoice_id }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.delivery_date }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.product_sku }}
                                    </td>
                                    <td class="srrv">
                                        {{ item.product_name }}
                                    </td>
                                    <td class="srrv">
                                        <div v-if="item.order_type == 'home_delivery'">
                                            <b-alert show variant="primary" style="padding: 2px; font-size: 11px; text-align: center;">HOME DELIVERY</b-alert>
                                        </div>
                                        <div v-else-if="item.order_type == 'store_pickup'">
                                            <b-alert show variant="warning" style="padding: 2px; font-size: 11px; text-align: center;">STORE PICKUP</b-alert>
                                        </div>
                                        <div v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            <b-alert show variant="info" style="padding: 2px; font-size: 11px; text-align: center;">STORE TRANSFER</b-alert>
                                        </div>
                                          <div v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                            <b-alert show variant="secondary" style="padding: 2px; font-size: 11px; text-align: center;">DAMAGE ORDER</b-alert>
                                        </div>
                                        <div v-else>
                                            {{item.order_type}}
                                        </div>
                                    </td>
                                    <td class="srrv">
                                        {{ item.quantity }}
                                    </td>
                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{item.locsub === "0" ? "MECCA WHOLESALE" : packet.locsubsdict[item.original_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            {{packet.locsubsdict[item.original_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                            {{packet.locsubsdict[item.locsub] || item.locsub}}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.locsubsdict[item.ship_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            {{packet.locsubsdict[item.ship_locsub]}}
                                        </span>
                                         <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                            {{packet.locsubsdict[item.ship_locsub] || item.ship_locsub}}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                            {{packet.locsubsdict[item.drop_locsub]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                            {{packet.locsubsdict[item.drop_locsub] || item.drop_locsub}}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                        <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                            {{packet.trucksdict[item.pickup_truck]}}
                                        </span>
                                        <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                             {{packet.trucksdict[item.pickup_truck]}}
                                        </span>
                                    </td>
                                    <td class="srrv">
                                   <b-form-select
                                        size="sm"
                                        :style="{textAlign: 'left'}"
                                        :options="getFilteredStates(item)"
                                        v-model="item.state"
                                        v-on:change="update_invoice_item_state(item)"
                                        :disabled="item.state !== 30 && packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK'"
                                        class="glass-status-select"
                                    ></b-form-select>
                                    </td>
                                    <td class="srrv hidden-print">
                                        <button class="glass-comment-btn" @click="show_comments(item)">CMNT</button>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>
                    <div v-else-if="items.length > 0 && filtered.length === 0">
                        <b-alert variant="info" show class="glass-empty-alert">
                            No items match the selected filters.
                        </b-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { BIconFunnelFill } from 'bootstrap-vue'

    import ItemComments from '@/components/importables/ItemComments'
import { text } from 'd3';

    export default {
        name: "Incoming",
        components: {flatPickr, Loading, ItemComments, DatePicker},
        data: function(){
            let out = {
                items: [],
                date_range: [],
                picked_date_range: null,
                dates: [],
                drop_location: null,
                active_date:null,
                years: [
                    {value: 2022, text: 2022},
                    {value: 2023, text: 2023},
                    {value: 2024, text: 2024},
                    {value: 2025, text: 2025},
                    {value: 2026, text: 2026},
                    {value: 2027, text: 2027},
                    {value: 2028, text: 2028},
                    {value: 2029, text: 2029},
                    {value: 2030, text: 2030},
                    {value: 2031, text: 2031},
                    {value: 2032, text: 2032},
                    {value: 2033, text: 2033},
                    {value: 2034, text: 2034},
                    {value: 2035, text: 2035},
                ],
                months: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ],
                year: null,
                month: null,
                picked_date: null,
                picked_location_id: null,
                picked_pickup_truck: null,

                packet: {},
                items_being_loaded: false,
                dates_being_loaded: false,
                current_date: null,
                type: 'incoming',
                locsubs: [],
                locsub: null,
                filtersVisible: false,
                isMobile: false,
states: mappings.states.map(function(d){
    // Create the state options with custom text for specific values
    let stateOption = {...d};

    // Map the text values as requested
    if(d.value == 9) stateOption.text = "RECEIVED FROM WAREHOUSE";
    if(d.value == -9) stateOption.text = "CANT RECEIVED FROM WAREHOUSE";


    return stateOption;
}),
                states_outgoing_current: mappings.states,
                states_outgoing_new: mappings.states,
                states_dict: mappings.states_dict,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                comments_dict: {},
                sort_asc: true,
                trucks: [],
                incoming_types: [
                    {value: null, text: "ALL"},
                    {value: "CUSTOMER_ORDER", text: "CUSTOMER ORDER"},
                    {value: "STORE_TRANSFER_ORDER", text: "STORE TRANSFER ORDER"},
                ],
                picked_incoming_type: null,
                selected_state: "open",

                // New filter data
                selected_date: null,
                selected_driver: null,
                selected_status: null,
                selected_order_type: null,
                selected_pick_from: null, // New filter for Item Pick From
                selected_drop_location: null, // New filter for Drop Location
                selected_delivery_location: null, // New filter for Delivery Location
                available_dates: [],
                available_drivers: [],
                available_statuses: [], // Dynamic status options
                available_pick_from_locations: [], // Options for Item Pick From filter
                available_drop_locations: [], // Options for Drop Location filter
                available_delivery_locations: [], // Options for Delivery Location filter
                available_order_types: [], // Dynamic order type options
              status_options: [
    {value: null, text: "ALL STATUS"},
    {value: 0, text: "ORDERED"},
    {value: 2, text: "PULLED"},
    {value: -2, text: "CANT PULLED"},
    {value: 3, text: "PICKED FROM WAREHOUSE"},
    {value: -3, text: "CANT PICK FROM WAREHOUSE"},
    {value: 30, text: "DROPPED"},
    {value: -30, text: "CANNOT BE DROPPED"},
    {value: 9, text: "RECEIVED FROM WAREHOUSE"},
    {value: -9, text: "CANT RECEIVED FROM WAREHOUSE"},
    {value: 5, text: "READY TO SHIP"}, // Added
    {value: -5, text: "CANT READY TO SHIP"}, // Added

],
                // Loading animation properties
                apiLoading: false,
                loadingMessage: 'Loading Incoming Items',
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "📦 Fetching incoming items...",
                    "🚚 Loading delivery schedules...",
                    "📍 Syncing location data...",
                    "📊 Processing orders...",
                    "🔄 Updating inventory...",
                    "✨ Organizing items...",
                    "📈 Preparing data..."
                ]
            }
            return out;
        },
        mounted() {
          this.handleResize()
          window.addEventListener('resize', this.handleResize)
        },
        beforeDestroy() {
          window.removeEventListener('resize', this.handleResize)
        },
        computed: {
      filtered: function(){
            let that = this;
            return this.items.filter(function(d){
                // Date filter
                const dateMatch = that.selected_date ? d.delivery_date === that.selected_date : true;

                // Driver filter
                const driverMatch = that.selected_driver ?
                    (d.pickup_truck == that.selected_driver || d.truck == that.selected_driver) : true;

                // Status filter
                const statusMatch = that.selected_status !== null ?
                    d.state === that.selected_status : true;

                // Order type filter
                  // Order type filter - updated to handle store transfer
        const orderTypeMatch = that.selected_order_type ?
            (d.order_type === that.selected_order_type ||
             (that.selected_order_type === 'store_transfer' && d.incoming_type === 'STORE_TRANSFER_ORDER')) : true;


                // Item Pick From filter
                const pickFromMatch = that.selected_pick_from !== null ?
                    that.getItemPickFromLocation(d) === that.selected_pick_from : true;

                // Drop Location filter
                const dropLocationMatch = that.selected_drop_location !== null ?
                    that.getDropLocation(d) === that.selected_drop_location : true;

                // Delivery Location filter
                const deliveryLocationMatch = that.selected_delivery_location !== null ?
                    that.getDeliveryLocation(d) === that.selected_delivery_location : true;

                return dateMatch && driverMatch && statusMatch && orderTypeMatch && 
                       pickFromMatch && dropLocationMatch && deliveryLocationMatch;
            });
        }
        },
        watch: {
            // Watch all filter changes to update available options dynamically
            selected_date: function(newDate) {
                this.updateAllAvailableOptions();
            },
            selected_driver: function(newDriver) {
                this.updateAllAvailableOptions();
            },
            selected_status: function(newStatus) {
                this.updateAllAvailableOptions();
            },
            selected_order_type: function(newOrderType) {
                this.updateAllAvailableOptions();
            },
            selected_pick_from: function(newPickFrom) {
                this.updateAllAvailableOptions();
            },
            selected_drop_location: function(newDropLocation) {
                this.updateAllAvailableOptions();
            },
            selected_delivery_location: function(newDeliveryLocation) {
                this.updateAllAvailableOptions();
            },
            items: function(newItems) {
                this.updateAllAvailableOptions();
            }
        },
        methods: {
            // Loading animation methods
            startApiLoading(message = 'Loading Incoming Items') {
                this.apiCallStack++;
                if (!this.apiLoading) {
                    this.startLoadingAnimation(message);
                } else {
                    this.loadingMessage = message;
                }
            },
            stopApiLoading() {
                this.apiCallStack--;
                if (this.apiCallStack <= 0 && this.apiLoading) {
                    this.stopLoadingAnimation(true);
                }
            },
            startLoadingAnimation(message = 'Loading Incoming Items') {
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 10;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    }
                }, 2000);
                
                let messages = ['Loading Items', 'Fetching Data', 'Processing Records', 'Updating List', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 1800);
            },
            stopLoadingAnimation(success = true) {
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                if (success) {
                    this.loadingProgress = 100;
                    setTimeout(() => {
                        this.apiLoading = false;
                    }, 500);
                } else {
                    this.apiLoading = false;
                }
            },

            handleResize() {
              this.isMobile = window.innerWidth < 768
            },
            // Main method to update all available options based on current filters
            updateAllAvailableOptions() {
                const filteredItems = this.getCurrentlyFilteredItems();
                this.updateAvailableDates(filteredItems);
                this.updateAvailableDrivers(filteredItems);
                this.updateAvailableStatuses(filteredItems);
                this.updateAvailableLocations(filteredItems);
                this.updateAvailableOrderTypes(filteredItems);
            },
            // Get items filtered by all current selections
            getCurrentlyFilteredItems() {
                let that = this;
                return this.items.filter(function(item) {
                    // Apply all current filters except the one being updated
                    const dateMatch = that.selected_date ? item.delivery_date === that.selected_date : true;
                    const driverMatch = that.selected_driver ?
                        (item.pickup_truck == that.selected_driver || item.truck == that.selected_driver) : true;
                    const statusMatch = that.selected_status !== null ? item.state === that.selected_status : true;
                    const orderTypeMatch = that.selected_order_type ? 
                        (item.order_type === that.selected_order_type ||
                         (that.selected_order_type === 'store_transfer' && item.incoming_type === 'STORE_TRANSFER_ORDER')) : true;
                    const pickFromMatch = that.selected_pick_from !== null ?
                        that.getItemPickFromLocation(item) === that.selected_pick_from : true;
                    const dropLocationMatch = that.selected_drop_location !== null ?
                        that.getDropLocation(item) === that.selected_drop_location : true;
                    const deliveryLocationMatch = that.selected_delivery_location !== null ?
                        that.getDeliveryLocation(item) === that.selected_delivery_location : true;

                    return dateMatch && driverMatch && statusMatch && orderTypeMatch && 
                           pickFromMatch && dropLocationMatch && deliveryLocationMatch;
                });
            },
           getItemPickFromLocation(item) {
                    if (item.incoming_type == 'CUSTOMER_ORDER') {
                        return item.locsub === "0" ? "MECCA WHOLESALE" : this.packet.locsubsdict[item.original_locsub];
                    } else if (item.incoming_type == 'STORE_TRANSFER_ORDER') {
                        return item.locsub === "0" ? "MECCA WHOLESALE" : this.packet.locationsdict[item.original_locsub];
                    } else if (item.incoming_type == 'DAMAGE_ORDER') {
                        // For damage orders, use locsub which contains the original location
                        return this.packet.locsubsdict[item.locsub] || item.locsub;
                    }
                    return "";
                },
           getDropLocation(item) {
                if (item.incoming_type == 'CUSTOMER_ORDER') {
                    return this.packet.locsubsdict[item.ship_locsub];
                } else if (item.incoming_type == 'STORE_TRANSFER_ORDER') {
                    return this.packet.locationsdict[item.ship_locsub];
                } else if (item.incoming_type == 'DAMAGE_ORDER') {
                    // For damage orders, ship_locsub contains the staging location
                    return this.packet.locsubsdict[item.ship_locsub] || item.ship_locsub;
                }
                return "";
            },
           getDeliveryLocation(item) {
                if (item.incoming_type == 'CUSTOMER_ORDER') {
                    return this.packet.locsubsdict[item.drop_locsub];
                } else if (item.incoming_type == 'STORE_TRANSFER_ORDER') {
                    return this.packet.locationsdict[item.drop_locsub];
                } else if (item.incoming_type == 'DAMAGE_ORDER') {
                    return this.packet.locsubsdict[item.drop_locsub] || item.drop_locsub;
                }
                return "";
            },
         updateAvailableDates(filteredItems = null) {
    // Always use the full items array to show ALL available dates
    const itemsToUse = this.items; // Changed from filteredItems || this.items

    const dateCounts = {};
    itemsToUse.forEach(item => {
        if (item.delivery_date) {
            dateCounts[item.delivery_date] = (dateCounts[item.delivery_date] || 0) + 1;
        }
    });

    this.available_dates = [
        { value: null, text: 'All Dates' },
        ...Object.keys(dateCounts).map(date => ({
            value: date,
            text: `${date} (${dateCounts[date]})`
        })).sort((a, b) => new Date(a.value) - new Date(b.value)) // Optional: sort dates chronologically
    ];
},
            updateAvailableDrivers(filteredItems = null) {
                const itemsToUse = filteredItems || this.items;
                const driverSet = new Set();

                itemsToUse.forEach(item => {
                    if (item.pickup_truck && this.packet.trucksdict[item.pickup_truck]) {
                        driverSet.add(item.pickup_truck);
                    }
                    if (item.truck && this.packet.trucksdict[item.truck]) {
                        driverSet.add(item.truck);
                    }
                });

                this.available_drivers = [
                    { value: null, text: 'ALL DRIVERS' },
                    ...Array.from(driverSet).map(driverKey => ({
                        value: driverKey,
                        text: this.packet.trucksdict[driverKey] || driverKey
                    })).sort((a, b) => a.text.localeCompare(b.text))
                ];
            },
            updateAvailableStatuses(filteredItems = null) {
                const itemsToUse = filteredItems || this.items;
                const statusCounts = {};
                itemsToUse.forEach(item => {
                    if (item.state !== null && item.state !== undefined) {
                        statusCounts[item.state] = (statusCounts[item.state] || 0) + 1;
                    }
                });

                // Update status options with counts from current filtered items
                this.available_statuses = [
                    { value: null, text: 'ALL STATUS' },
                    ...this.status_options
                        .filter(opt => opt.value !== null && statusCounts[opt.value])
                        .map(opt => ({
                            ...opt,
                            text: `${opt.text} (${statusCounts[opt.value] || 0})`
                        }))
                ];
            },
            updateAvailableLocations(filteredItems = null) {
                const itemsToUse = filteredItems || this.items;
                const pickFromSet = new Set();
                const dropLocationSet = new Set();
                const deliveryLocationSet = new Set();

                itemsToUse.forEach(item => {
                    // Get Item Pick From location
                    const pickFromLocation = this.getItemPickFromLocation(item);
                    if (pickFromLocation) {
                        pickFromSet.add(pickFromLocation);
                    }

                    // Get Drop Location
                    const dropLocation = this.getDropLocation(item);
                    if (dropLocation) {
                        dropLocationSet.add(dropLocation);
                    }

                    // Get Delivery Location
                    const deliveryLocation = this.getDeliveryLocation(item);
                    if (deliveryLocation) {
                        deliveryLocationSet.add(deliveryLocation);
                    }
                });

                // Update Item Pick From options
                this.available_pick_from_locations = [
                    { value: null, text: 'ALL LOCATIONS' },
                    ...Array.from(pickFromSet).map(location => ({
                        value: location,
                        text: location
                    })).sort((a, b) => a.text.localeCompare(b.text))
                ];

                // Update Drop Location options
                this.available_drop_locations = [
                    { value: null, text: 'ALL LOCATIONS' },
                    ...Array.from(dropLocationSet).map(location => ({
                        value: location,
                        text: location
                    })).sort((a, b) => a.text.localeCompare(b.text))
                ];

                // Update Delivery Location options
                this.available_delivery_locations = [
                    { value: null, text: 'ALL LOCATIONS' },
                    ...Array.from(deliveryLocationSet).map(location => ({
                        value: location,
                        text: location
                    })).sort((a, b) => a.text.localeCompare(b.text))
                ];
            },
         updateAvailableOrderTypes(filteredItems = null) {
    const itemsToUse = filteredItems || this.items;
    const orderTypeCounts = {};

    itemsToUse.forEach(item => {
        let typeKey = '';
        let typeName = '';

        // Determine order type
        if (item.incoming_type === 'STORE_TRANSFER_ORDER') {
            typeKey = 'store_transfer';
            typeName = 'STORE TRANSFER';
        } else if (item.incoming_type === 'DAMAGE_ORDER') {
            typeKey = 'damage_order';
            typeName = 'DAMAGE ORDER';
        } else if (item.order_type === 'home_delivery') {
            typeKey = 'home_delivery';
            typeName = 'HOME DELIVERY';
        } else if (item.order_type === 'store_pickup') {
            typeKey = 'store_pickup';
            typeName = 'STORE PICKUP';
        } else {
            // Fallback for any other types
            typeKey = item.order_type || item.incoming_type || 'unknown';
            typeName = typeKey.toUpperCase().replace(/_/g, ' ');
        }

        orderTypeCounts[typeKey] = (orderTypeCounts[typeKey] || 0) + 1;
    });

    this.available_order_types = [
        { value: null, text: 'ALL TYPES' },
        ...Object.keys(orderTypeCounts).map(orderType => {
            let displayText = '';
            switch(orderType) {
                case 'home_delivery':
                    displayText = 'HOME DELIVERY';
                    break;
                case 'store_pickup':
                    displayText = 'STORE PICKUP';
                    break;
                case 'store_transfer':
                    displayText = 'STORE TRANSFER';
                    break;
                case 'damage_order':
                    displayText = 'DAMAGE ORDER';
                    break;
                default:
                    displayText = orderType.toUpperCase().replace(/_/g, ' ');
            }
            return {
                value: orderType,
                text: `${displayText} (${orderTypeCounts[orderType]})`
            };
        })
    ];
},
getFilteredStates(item) {
    let userrole = this.packet.userDetails.userrole;
    
    // Get ALL states from mappings to show to EVERYONE
    const allStates = this.states;

    // Check if drop_locsub is Mecca Shipping (47)
    const isMeccaShipping = item.drop_locsub === "47" ||
                           (item.incoming_type === 'CUSTOMER_ORDER' &&
                            this.packet.locsubsdict[item.drop_locsub] &&
                            this.packet.locsubsdict[item.drop_locsub].includes("MECCA SHIPPING"));

    // Define selectable states based on user role and item conditions
    const getSelectableStates = () => {
        // For admin: ALL states are selectable
        if (userrole === "admin") {
            return allStates.map(state => state.value);
        }
        
        // For non-admin users: specific business logic
        const allowedStates = [30, 9, -9, 5, -5];
        
        // Only allow state changes if current state is in allowed states
        if (!allowedStates.includes(item.state)) {
            return [item.state]; // Only current state is selectable
        }
        
        // If we reach here, current state is in allowedStates
        let selectable = [30, 9, -9]; // Base states for non-admin
        
        // Add Mecca Shipping specific states
        if (isMeccaShipping) {
            selectable.push(5, -5);
        }
        
        return selectable;
    };

    const selectableStates = getSelectableStates();
    
    // Return all states with proper enabling
    return allStates.map(state => {
        const isSelectable = selectableStates.includes(state.value);
        
        // Current state should always be enabled so it's visible in dropdown
        if (state.value === item.state) {
            return {
                ...state,
                disabled: false,
                // You can add a marker for current state if desired
                text: `${state.text}`
            };
        }
        
        return {
            ...state,
            disabled: !isSelectable,
            // For visual distinction
            text: isSelectable ? state.text : `${state.text}`
        };
    });
},
         getStatusText(state) {
    // Find the status text from mappings.states
    const statusObj = mappings.states.find(s => s.value === state);
    return statusObj ? statusObj.text : "UNKNOWN";
},
            getDriverKey(driverName) {
                // Find the key in trucksdict that matches the driver name
                for (const [key, value] of Object.entries(this.packet.trucksdict)) {
                    if (value === driverName) {
                        return key;
                    }
                }
                return driverName; // fallback
            },
            allowed: function(item){
                let status = true
                let allowed_item = this.allowed_item(item);
                let filtered_location = this.filtered_location(item);
                let filtered_pickup_truck = this.filtered_pickup_truck(item);

                if (allowed_item && filtered_location && filtered_pickup_truck){
                    status = true
                }
                else {
                    status = false
                }
                return status
            },
            allowed_item: function(item){
                let status = true;
                let userrole = this.packet.userDetails.userrole;
                let item_location_id = item.drop_location;

                if (userrole == "admin" || userrole == "officeuser") {
                    status = true;
                }
                else {
                    if (this.packet.userDetails.properties.location_id) {
                        let location_id = parseInt(this.packet.userDetails.properties.location_id);
                        if (location_id == item.item_location_id){
                            status = true
                        }
                        else {
                            status = false
                        }
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },
            filtered_location: function(item){
                let status = true;
                if (this.picked_location_id) {
                    if (item.drop_location == this.picked_location_id){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },
            filtered_pickup_truck: function(item){
                let status = true;
                if (this.picked_pickup_truck) {
                    if (item.pickup_truck == this.picked_pickup_truck){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                return status
            },
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-comments");
            },
           update_invoice_item_state: function(item){
    let path = "/api/sales/update_invoice_item_state/"
    let that = this;

    let data = {
        invoice_id: item.invoice_id,
        itemid: item.itemid,
        state: item.state,
        changed_by: this.packet.userDetails.username,
        product_sku: item.product_sku,
        quantity: item.quantity,
        incoming_type: item.incoming_type // Add this line
    }

    let s = function(response) {
        if (response.data.error){
            that.$bvToast.toast(
                response.data.error,
                {title: "Error", autoHideDelay: 1500, variant:"warning"}
            );
            that.fetch_init2(); // Reload the data to get correct states
        }
        else {
            that.$bvToast.toast(
                "Success updating item state.",
                {title: "Success", autoHideDelay: 1500, variant:"success"}
            );
            that.fetch_init2();
        }
    }

    let f = function(error) {
        console.log(error)
        that.$bvToast.toast(
            "Error updating item state.",
            {title: "Error", autoHideDelay: 1500, variant:"danger"}
        );
        that.fetch_init2();
    }
    Requestor.postAsync(path, data, s, f);
},
            get_items_for_date: function(date){
                this.active_date = date.date;
                let that = this;
                let path = ""
                if (this.type == 'incoming'){
                    path = "/api/sales/get_incoming_items/"
                }
                else {
                    path = "/api/sales/get_outgoing_items/"
                }

                if (!path){
                    return
                }
                let data = {locsub: this.locsub, date: date.date}
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                        that.updateAllAvailableOptions();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                    that.get_batch_comments();
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error fetching items for the date.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }
                this.items = [];
                this.items_being_loaded = true;
                Requestor.getSync(path, data, s, f);
            },
            get_batch_comments: function(){
                let items = [];
                for (var i =0; i<this.items.length; i++){
                    for (var j=0; j<this.items[i].items.length; j++){
                        items.push(
                            {
                                invoice_id: this.items[i].items[j].invoice_id,
                                itemid: this.items[i].items[j].itemid,
                            }
                        )
                    }
                }
                let path = "/api/sales/get_batch_comments/"
                let data = {items: items};
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        let comments = response.data.result;
                        if (comments.length > 0){
                            that.comments_dict = Object.assign({}, ...comments.map((x) => ({[x.invoice_id+'|'+x.itemid]: x.n_comments})));
                        }
                    }
                    else {
                        console.log(response.data.error)
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading comments.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postAsync(path, data, s, f);
            },
            fetch_init2: function(d){
                let path = "/api/sales/get_incoming_items_for_date_range/"
                let that = this;
                this.startApiLoading('Fetching Incoming Items');
                
                let data = {date_range: this.date_range.filter(d => d !== null), drop_location: this.drop_location};

                if (!data.drop_location && this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id){
                    this.$vex.dialog.alert({
                        message: "PICK AN INCOMING LOCATION"
                    });
                    this.stopApiLoading();
                    return
                }

                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                        that.updateAllAvailableOptions();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                    that.stopApiLoading();
                }

                this.items_being_loaded = true;
                this.items = [];
                // Reset filters
                this.selected_date = null;
                this.selected_driver = null;
                this.selected_order_type = null;
                this.selected_pick_from = null;
                this.selected_drop_location = null;
                this.selected_delivery_location = null; // NEW
                this.selected_status = null;
                Requestor.postSync(path, data, s, f);
            },
            get_incoming_items_for_date: function(){
                let path = "/api/sales/get_incoming_items_for_date/"
                let that = this;
                let data = {date: this.picked_date};
                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                        that.updateAllAvailableOptions();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                this.items = [];
                Requestor.postSync(path, data, s, f);
            },
            get_incoming_dates_for_year_month: function(){
                let path = "/api/sales/get_incoming_dates_for_year_month/"
                let that = this;
                let data = {year: this.year, month: this.month};
                if (this.packet.userDetails.properties.location_id){
                    data.location_id = this.packet.userDetails.properties.location_id;
                }
                let s = function(response) {
                    if (response.data.result){
                        that.dates = response.data.result;
                        that.dates = that.dates.map(function(d){
                            return {value: d.date, text: d.date + ' ('+d.nitems+')' }
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.dates_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading incoming dates.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.dates_being_loaded = false;
                }

                this.dates = [];
                this.items = [];
                this.picked_date = null;
                this.picked_location = null;
                Requestor.postAsync(path, data, s, f);
            },
            fetch_prereqs: function(){
            },
            fetch: function(type){
                this.type = type;
                this.items = []
                this.dates = []
                this.active_date = null;
                this.locsub = null;
            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            set_dates: function(value){
                let start = null;
                let end = null;

                if(value == 'today') {
                    start = moment().format("MM-DD-YYYY");
                    end = moment().format("MM-DD-YYYY");
                }
                if(value == 'yesterday') {
                    start = moment().add(-1, 'days').format("MM-DD-YYYY");
                    end = moment().add(-1, 'days').format("MM-DD-YYYY");
                }
                if(value == 'this_week') {
                    start = moment().startOf('week').format("MM-DD-YYYY");
                    end = moment().endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'last_week') {
                    start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
                }
                if(value == 'this_month') {
                    start = moment().startOf('month').format("MM-DD-YYYY");
                    end = moment().endOf('month').format("MM-DD-YYYY");
                }
                if(value == 'last_month') {
                    start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                    end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
                }

                if (start && end) {
                    this.date_range = [start , end]
                    this.picked_date_range = value;
                }
            },
             get_locations: function(){
    let output = [
        {value: null, text: "PICK LOCATION", disabled: true}
    ];

    if (this.packet.locations) {
        // Filter out the unwanted locations
        let filteredLocations = this.packet.locations.filter(location => {
            const locationText = location.text ? location.text.toUpperCase() : '';
            return !locationText.includes('OUT OF STOCK') &&
                   !locationText.includes('ONLINE SALES')
                //    !locationText.includes('ALL');
        });

        output = output.concat(filteredLocations);
    }

    return output;
}
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.trucks = this.packet.trucks;

            if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                let userLocation = this.packet.locations.find(item => [this.packet.userDetails.properties.location_id].includes(item.value))
                if (userLocation) {
                    this.drop_location = userLocation.value
                    this.fetch_init2();
                }
            };
        }
    }
</script>

<style scoped>
    /* Glass Theme Container */
    .incoming.glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
        padding: 24px;
    }

    /* Same background image as Delivery Operations */
    .incoming.glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    /* Glass Card Effect */
    .glass-alert,
    .glass-filters,
    .glass-empty-alert {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    /* Glass Table Card */
    .glass-table-card {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border-radius: 20px !important;
    }

    /* Glass Select */
    .glass-select {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 2px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }

    .glass-select:hover {
        background: rgba(255, 255, 255, 0.95) !important;
        border-color: rgba(0, 0, 0, 0.2) !important;
    }

    .glass-select:focus {
        border-color: #4299e1 !important;
        box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1) !important;
    }

    /* Glass Button */
    .glass-btn {
        background: linear-gradient(135deg, #28a745, #20c997) !important;
        border: none !important;
        color: white !important;
        transition: all 0.3s ease !important;
        border-radius: 12px !important;
        padding: 8px 20px !important;
    }

    .glass-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
    }

    .glass-filter-btn {
        background: rgba(0, 123, 255, 0.1) !important;
        border: 1px solid rgba(0, 123, 255, 0.3) !important;
        color: #007bff !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }

    .glass-filter-btn:hover {
        background: rgba(0, 123, 255, 0.2) !important;
        transform: scale(1.02);
    }

    /* Glass Comment Button */
    .glass-comment-btn {
        background: rgba(0, 123, 255, 0.1);
        border: 1px solid rgba(0, 123, 255, 0.3);
        color: #007bff;
        padding: 5px 10px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .glass-comment-btn:hover {
        background: rgba(0, 123, 255, 0.2);
        transform: scale(1.05);
    }

    /* Glass Status Select */
    .glass-status-select {
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
    }

    .glass-status-select:hover {
        transform: scale(1.02);
    }

    /* Glass Table */
    .glass-table {
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;
    }

    .glass-table-header {
        background: rgba(60, 60, 60, 0.9) !important;
        backdrop-filter: blur(5px);
        padding: 12px !important;
    }

    .glass-table-row {
        transition: all 0.3s ease;
    }

    .glass-table-row:hover {
        background: rgba(255, 255, 255, 0.7) !important;
        transform: scale(1.01);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    /* Existing styles */
    select option:disabled {
        color: #888 !important;
        font-style: italic;
        background-color: #f5f5f5 !important;
    }

    select option {
        padding: 8px 12px !important;
        font-size: 13px !important;
    }

    /* Different styling for enabled vs disabled options */
    select option:not(:disabled) {
        font-weight: 600;
        background-color: white !important;
    }

    select option[disabled] {
        border-bottom: 1px solid #e0e0e0;
    }

    /* Hover effect for enabled options */
    select option:not(:disabled):hover {
        background-color: #e8f5e9 !important;
    }

    /* Make the dropdown wider to accommodate all text */
    select[size="sm"] {
        min-width: 200px !important;
    }

    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }

    .srr {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        background: rgb(60, 60, 60);
        color: white;
        border: 1px solid #ffffff;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

    table {
        table-layout: fixed;
        width: 100%;
    }

    .ipt_tdr {
        background: none;
        text-align: center;
        font-size: 12px;
    }

    .ipt_tdhr {
        background: #343a40;
        color: white;
        font-weight: bold;
        text-align: center;
        font-size: 12px;
        border: 1px solid white;
    }

    /* ========== Loading Overlay Styles ========== */
    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-overlay-enter-active {
        animation: fadeIn 0.3s ease;
    }

    .loading-overlay-leave-active {
        animation: fadeOut 0.3s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }

    @keyframes cardPop {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .loading-animation {
        margin-bottom: 32px;
    }

    .loading-ring {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 4px solid transparent;
        border-radius: 50%;
        animation: ringRotate 1.5s linear infinite;
    }

    .ring:nth-child(1) {
        border-top-color: #4299e1;
        border-left-color: #4299e1;
        animation-duration: 1s;
    }

    .ring:nth-child(2) {
        border-right-color: #48bb78;
        border-bottom-color: #48bb78;
        width: 80%;
        height: 80%;
        top: 10%;
        left: 10%;
        animation-duration: 1.2s;
        animation-direction: reverse;
    }

    .ring:nth-child(3) {
        border-left-color: #ed8936;
        border-bottom-color: #ed8936;
        width: 60%;
        height: 60%;
        top: 20%;
        left: 20%;
        animation-duration: 0.8s;
    }

    @keyframes ringRotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-logo {
        font-size: 32px;
        font-weight: bold;
        animation: logoPulse 1.5s ease-in-out infinite;
        z-index: 1;
    }

    .loading-logo i {
        font-size: 40px;
        background: linear-gradient(135deg, #4299e1, #48bb78);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }

    @keyframes logoPulse {
        0%, 100% { transform: scale(1); opacity: 0.7; }
        50% { transform: scale(1.1); opacity: 1; }
    }

    .loading-text {
        margin-bottom: 24px;
    }

    .loading-text h3 {
        color: #2d3748;
        font-size: 1.3rem;
        margin-bottom: 8px;
        display: inline-block;
    }

    .loading-dots {
        display: inline-flex;
        margin-left: 8px;
    }

    .loading-dots .dot {
        width: 6px;
        height: 6px;
        background: #4299e1;
        border-radius: 50%;
        margin: 0 2px;
        animation: dotBounce 1.4s ease-in-out infinite;
    }

    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-8px); }
    }

    .loading-progress {
        width: 100%;
        height: 4px;
        background: #e2e8f0;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
        background-size: 200% 100%;
        animation: progressShine 1.5s linear infinite;
        transition: width 0.3s ease;
        border-radius: 4px;
    }

    @keyframes progressShine {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .loading-tips {
        margin-top: 20px;
    }

    .tip-text {
        color: #718096;
        font-size: 0.9rem;
        animation: tipFade 0.5s ease;
    }

    @keyframes tipFade {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 768px) {
        .incoming.glass-theme {
            padding: 16px;
        }

        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }

        .glass-btn {
            margin-top: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/MeccaReceiving.vue